/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { css } from '@emotion/react';
import { euiYScrollWithShadows, euiMaxBreakpoint } from '../../global_styling';
export var euiModalBodyStyles = function euiModalBodyStyles(euiThemeContext) {
  var euiTheme = euiThemeContext.euiTheme;
  return {
    euiModalBody: /*#__PURE__*/css("flex-grow:1;overflow:hidden;display:flex;flex-direction:column;&:last-of-type .euiModalBody__overflow{padding-block-end:", euiTheme.size.l, ";};label:euiModalBody;"),
    euiModalBody__overflow: /*#__PURE__*/css(euiYScrollWithShadows(euiThemeContext), ";padding-inline:", euiTheme.size.l, ";padding-block:", euiTheme.size.s, ";", euiMaxBreakpoint(euiThemeContext, 'm'), "{padding-block-end:", euiTheme.size.l, ";};label:euiModalBody__overflow;")
  };
};